export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11459.450e505d.jpg";